"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserRequestSuccessAction = exports.updateUserRequestFailAction = exports.updateUserRequestAction = exports.setInProcessAction = exports.selectUser = exports.selectTransferRecipientShops = exports.selectToken = exports.selectShops = exports.selectInSubmitProcess = exports.selectInProcess = exports.selectFile = exports.selectExchangeAmount = exports.selectCommissions = exports.selectCategories = exports.resetStateAction = exports.resetRegisterAction = exports.refreshTwoFARequestSuccessAction = exports.refreshTwoFARequestFailAction = exports.refreshTwoFARequestAction = exports.reducer = exports.name = exports.getUserRequestSuccessAction = exports.getUserRequestFailAction = exports.getUserRequestAction = exports.getTransferRecipientRequestSuccessAction = exports.getTransferRecipientRequestFailAction = exports.getTransferRecipientRequestAction = exports.getTokenDataRequestSuccessAction = exports.getTokenDataRequestFailAction = exports.getTokenDataRequestAction = exports.getShopsRequestSuccessAction = exports.getShopsRequestFailAction = exports.getShopsRequestAction = exports.getExchangeAmountRequestSuccessAction = exports.getExchangeAmountRequestFailAction = exports.getExchangeAmountRequestAction = exports.getCommissionRequestSuccessAction = exports.getCommissionRequestFailAction = exports.getCommissionRequestAction = exports.createUserRequestSuccessAction = exports.createUserRequestFailAction = exports.createUserRequestAction = exports.createShopRequestSuccessAction = exports.createShopRequestFailAction = exports.createShopRequestAction = exports.createPayoutsFromFileRequestSuccessAction = exports.createPayoutsFromFileRequestFailAction = exports.createPayoutsFromFileRequestAction = exports.createPayoutRequestSuccessAction = exports.createPayoutRequestFailAction = exports.createPayoutRequestAction = exports.createInvoiceRequestSuccessAction = exports.createInvoiceRequestFailAction = exports.createInvoiceRequestAction = exports.createExchangeRequestSuccessAction = exports.createExchangeRequestFailAction = exports.createExchangeRequestAction = exports.confirmTwoFARequestSuccessAction = exports.confirmTwoFARequestFailAction = exports.confirmTwoFARequestAction = exports.checkFileRequestSuccessAction = exports.checkFileRequestFailAction = exports.checkFileRequestAction = void 0;

var _toolkit = require("@reduxjs/toolkit");

var REDUCER_NAME = 'widget/button';
var initialState = {
  shops: [],
  user: null,
  commissions: [],
  exchangeAmount: [],
  file: null,
  inProcess: true,
  inSubmitProcess: false,
  transferRecipientShops: [],
  token: null
};
var slice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: initialState,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['shops'] = [];
      state['file'] = null;
      state['user'] = null;
      state['commissions'] = [];
      state['inProcess'] = true;
      state['inSubmitProcess'] = false;
      state['checkedInformation'] = {};
      state['transferRecipientShops'] = [];
      state['token'] = null;
    },
    setInProcessAction: function setInProcessAction(state, _ref) {
      var payload = _ref.payload;
      state['inProcess'] = payload;
    },
    resetRegisterAction: function resetRegisterAction(state) {
      state['file'] = null;
      state['inProcess'] = false;
    },
    getShopsRequestAction: function getShopsRequestAction(state) {
      state['inProcess'] = true;
    },
    getShopsRequestFailAction: function getShopsRequestFailAction(state) {
      state['inProcess'] = false;
    },
    getShopsRequestSuccessAction: function getShopsRequestSuccessAction(state, _ref2) {
      var payload = _ref2.payload;
      state['shops'] = payload;
      state['inProcess'] = false;
    },
    getTransferRecipientRequestAction: function getTransferRecipientRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    getTransferRecipientRequestFailAction: function getTransferRecipientRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    getTransferRecipientRequestSuccessAction: function getTransferRecipientRequestSuccessAction(state, _ref3) {
      var payload = _ref3.payload;
      state['transferRecipientShops'] = payload;
      state['inSubmitProcess'] = false;
    },
    getCommissionRequestAction: function getCommissionRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    getCommissionRequestFailAction: function getCommissionRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    getCommissionRequestSuccessAction: function getCommissionRequestSuccessAction(state, _ref4) {
      var payload = _ref4.payload;
      state['commissions'] = payload;
      state['inSubmitProcess'] = false;
    },
    getUserRequestAction: function getUserRequestAction(state) {
      state['inProcess'] = true;
    },
    getUserRequestFailAction: function getUserRequestFailAction(state) {
      state['inProcess'] = false;
    },
    getUserRequestSuccessAction: function getUserRequestSuccessAction(state, _ref5) {
      var payload = _ref5.payload;
      state['inProcess'] = false;
      state['user'] = payload;
    },
    createInvoiceRequestAction: function createInvoiceRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    createInvoiceRequestFailAction: function createInvoiceRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    createInvoiceRequestSuccessAction: function createInvoiceRequestSuccessAction(state) {
      state['inSubmitProcess'] = false;
    },
    createShopRequestAction: function createShopRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    createShopRequestFailAction: function createShopRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    createShopRequestSuccessAction: function createShopRequestSuccessAction(state) {
      state['inSubmitProcess'] = false;
    },
    createUserRequestAction: function createUserRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    createUserRequestFailAction: function createUserRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    createUserRequestSuccessAction: function createUserRequestSuccessAction(state) {
      state['inSubmitProcess'] = false;
    },
    createPayoutsFromFileRequestAction: function createPayoutsFromFileRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    createPayoutsFromFileRequestFailAction: function createPayoutsFromFileRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    createPayoutsFromFileRequestSuccessAction: function createPayoutsFromFileRequestSuccessAction(state) {
      state['inSubmitProcess'] = false;
    },
    createPayoutRequestAction: function createPayoutRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    createPayoutRequestFailAction: function createPayoutRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    createPayoutRequestSuccessAction: function createPayoutRequestSuccessAction(state) {
      state['inSubmitProcess'] = false;
    },
    updateUserRequestAction: function updateUserRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    updateUserRequestFailAction: function updateUserRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    updateUserRequestSuccessAction: function updateUserRequestSuccessAction(state) {
      state['inSubmitProcess'] = false;
    },
    checkFileRequestAction: function checkFileRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    checkFileRequestFailAction: function checkFileRequestFailAction(state) {
      state['file'] = null;
      state['inSubmitProcess'] = false;
    },
    checkFileRequestSuccessAction: function checkFileRequestSuccessAction(state, _ref6) {
      var payload = _ref6.payload;
      state['file'] = payload;
      state['inSubmitProcess'] = false;
    },
    confirmTwoFARequestAction: function confirmTwoFARequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    confirmTwoFARequestFailAction: function confirmTwoFARequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    confirmTwoFARequestSuccessAction: function confirmTwoFARequestSuccessAction(state) {
      state['inSubmitProcess'] = false;
    },
    getTokenDataRequestAction: function getTokenDataRequestAction(state) {},
    getTokenDataRequestFailAction: function getTokenDataRequestFailAction(state) {},
    getTokenDataRequestSuccessAction: function getTokenDataRequestSuccessAction(state, _ref7) {
      var payload = _ref7.payload;
      state['token'] = payload;
    },
    refreshTwoFARequestAction: function refreshTwoFARequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    refreshTwoFARequestFailAction: function refreshTwoFARequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    refreshTwoFARequestSuccessAction: function refreshTwoFARequestSuccessAction(state, _ref8) {
      var payload = _ref8.payload;
      state['inSubmitProcess'] = false;
      state['token'] = payload;
    },
    createExchangeRequestAction: function createExchangeRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    createExchangeRequestFailAction: function createExchangeRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    createExchangeRequestSuccessAction: function createExchangeRequestSuccessAction(state) {
      state['inSubmitProcess'] = false;
    },
    getExchangeAmountRequestAction: function getExchangeAmountRequestAction(state) {
      state['inSubmitProcess'] = true;
    },
    getExchangeAmountRequestFailAction: function getExchangeAmountRequestFailAction(state) {
      state['inSubmitProcess'] = false;
    },
    getExchangeAmountRequestSuccessAction: function getExchangeAmountRequestSuccessAction(state, _ref9) {
      var payload = _ref9.payload;
      state['exchangeAmount'] = payload;
      state['inSubmitProcess'] = false;
    }
  }
});
var _slice$actions = slice['actions'],
    resetStateAction = _slice$actions.resetStateAction,
    setInProcessAction = _slice$actions.setInProcessAction,
    resetRegisterAction = _slice$actions.resetRegisterAction,
    getShopsRequestAction = _slice$actions.getShopsRequestAction,
    getShopsRequestFailAction = _slice$actions.getShopsRequestFailAction,
    getShopsRequestSuccessAction = _slice$actions.getShopsRequestSuccessAction,
    getTransferRecipientRequestAction = _slice$actions.getTransferRecipientRequestAction,
    getTransferRecipientRequestFailAction = _slice$actions.getTransferRecipientRequestFailAction,
    getTransferRecipientRequestSuccessAction = _slice$actions.getTransferRecipientRequestSuccessAction,
    getCommissionRequestAction = _slice$actions.getCommissionRequestAction,
    getCommissionRequestFailAction = _slice$actions.getCommissionRequestFailAction,
    getCommissionRequestSuccessAction = _slice$actions.getCommissionRequestSuccessAction,
    getUserRequestAction = _slice$actions.getUserRequestAction,
    getUserRequestFailAction = _slice$actions.getUserRequestFailAction,
    getUserRequestSuccessAction = _slice$actions.getUserRequestSuccessAction,
    createInvoiceRequestAction = _slice$actions.createInvoiceRequestAction,
    createInvoiceRequestFailAction = _slice$actions.createInvoiceRequestFailAction,
    createInvoiceRequestSuccessAction = _slice$actions.createInvoiceRequestSuccessAction,
    createShopRequestAction = _slice$actions.createShopRequestAction,
    createShopRequestFailAction = _slice$actions.createShopRequestFailAction,
    createShopRequestSuccessAction = _slice$actions.createShopRequestSuccessAction,
    createUserRequestAction = _slice$actions.createUserRequestAction,
    createUserRequestFailAction = _slice$actions.createUserRequestFailAction,
    createUserRequestSuccessAction = _slice$actions.createUserRequestSuccessAction,
    createPayoutsFromFileRequestAction = _slice$actions.createPayoutsFromFileRequestAction,
    createPayoutsFromFileRequestFailAction = _slice$actions.createPayoutsFromFileRequestFailAction,
    createPayoutsFromFileRequestSuccessAction = _slice$actions.createPayoutsFromFileRequestSuccessAction,
    createPayoutRequestAction = _slice$actions.createPayoutRequestAction,
    createPayoutRequestFailAction = _slice$actions.createPayoutRequestFailAction,
    createPayoutRequestSuccessAction = _slice$actions.createPayoutRequestSuccessAction,
    updateUserRequestAction = _slice$actions.updateUserRequestAction,
    updateUserRequestFailAction = _slice$actions.updateUserRequestFailAction,
    updateUserRequestSuccessAction = _slice$actions.updateUserRequestSuccessAction,
    checkFileRequestAction = _slice$actions.checkFileRequestAction,
    checkFileRequestFailAction = _slice$actions.checkFileRequestFailAction,
    checkFileRequestSuccessAction = _slice$actions.checkFileRequestSuccessAction,
    confirmTwoFARequestAction = _slice$actions.confirmTwoFARequestAction,
    confirmTwoFARequestFailAction = _slice$actions.confirmTwoFARequestFailAction,
    confirmTwoFARequestSuccessAction = _slice$actions.confirmTwoFARequestSuccessAction,
    refreshTwoFARequestAction = _slice$actions.refreshTwoFARequestAction,
    refreshTwoFARequestFailAction = _slice$actions.refreshTwoFARequestFailAction,
    refreshTwoFARequestSuccessAction = _slice$actions.refreshTwoFARequestSuccessAction,
    getTokenDataRequestAction = _slice$actions.getTokenDataRequestAction,
    getTokenDataRequestFailAction = _slice$actions.getTokenDataRequestFailAction,
    getTokenDataRequestSuccessAction = _slice$actions.getTokenDataRequestSuccessAction,
    createExchangeRequestAction = _slice$actions.createExchangeRequestAction,
    createExchangeRequestFailAction = _slice$actions.createExchangeRequestFailAction,
    createExchangeRequestSuccessAction = _slice$actions.createExchangeRequestSuccessAction,
    getExchangeAmountRequestAction = _slice$actions.getExchangeAmountRequestAction,
    getExchangeAmountRequestFailAction = _slice$actions.getExchangeAmountRequestFailAction,
    getExchangeAmountRequestSuccessAction = _slice$actions.getExchangeAmountRequestSuccessAction;
exports.getExchangeAmountRequestSuccessAction = getExchangeAmountRequestSuccessAction;
exports.getExchangeAmountRequestFailAction = getExchangeAmountRequestFailAction;
exports.getExchangeAmountRequestAction = getExchangeAmountRequestAction;
exports.createExchangeRequestSuccessAction = createExchangeRequestSuccessAction;
exports.createExchangeRequestFailAction = createExchangeRequestFailAction;
exports.createExchangeRequestAction = createExchangeRequestAction;
exports.getTokenDataRequestSuccessAction = getTokenDataRequestSuccessAction;
exports.getTokenDataRequestFailAction = getTokenDataRequestFailAction;
exports.getTokenDataRequestAction = getTokenDataRequestAction;
exports.refreshTwoFARequestSuccessAction = refreshTwoFARequestSuccessAction;
exports.refreshTwoFARequestFailAction = refreshTwoFARequestFailAction;
exports.refreshTwoFARequestAction = refreshTwoFARequestAction;
exports.confirmTwoFARequestSuccessAction = confirmTwoFARequestSuccessAction;
exports.confirmTwoFARequestFailAction = confirmTwoFARequestFailAction;
exports.confirmTwoFARequestAction = confirmTwoFARequestAction;
exports.checkFileRequestSuccessAction = checkFileRequestSuccessAction;
exports.checkFileRequestFailAction = checkFileRequestFailAction;
exports.checkFileRequestAction = checkFileRequestAction;
exports.updateUserRequestSuccessAction = updateUserRequestSuccessAction;
exports.updateUserRequestFailAction = updateUserRequestFailAction;
exports.updateUserRequestAction = updateUserRequestAction;
exports.createPayoutRequestSuccessAction = createPayoutRequestSuccessAction;
exports.createPayoutRequestFailAction = createPayoutRequestFailAction;
exports.createPayoutRequestAction = createPayoutRequestAction;
exports.createPayoutsFromFileRequestSuccessAction = createPayoutsFromFileRequestSuccessAction;
exports.createPayoutsFromFileRequestFailAction = createPayoutsFromFileRequestFailAction;
exports.createPayoutsFromFileRequestAction = createPayoutsFromFileRequestAction;
exports.createUserRequestSuccessAction = createUserRequestSuccessAction;
exports.createUserRequestFailAction = createUserRequestFailAction;
exports.createUserRequestAction = createUserRequestAction;
exports.createShopRequestSuccessAction = createShopRequestSuccessAction;
exports.createShopRequestFailAction = createShopRequestFailAction;
exports.createShopRequestAction = createShopRequestAction;
exports.createInvoiceRequestSuccessAction = createInvoiceRequestSuccessAction;
exports.createInvoiceRequestFailAction = createInvoiceRequestFailAction;
exports.createInvoiceRequestAction = createInvoiceRequestAction;
exports.getUserRequestSuccessAction = getUserRequestSuccessAction;
exports.getUserRequestFailAction = getUserRequestFailAction;
exports.getUserRequestAction = getUserRequestAction;
exports.getCommissionRequestSuccessAction = getCommissionRequestSuccessAction;
exports.getCommissionRequestFailAction = getCommissionRequestFailAction;
exports.getCommissionRequestAction = getCommissionRequestAction;
exports.getTransferRecipientRequestSuccessAction = getTransferRecipientRequestSuccessAction;
exports.getTransferRecipientRequestFailAction = getTransferRecipientRequestFailAction;
exports.getTransferRecipientRequestAction = getTransferRecipientRequestAction;
exports.getShopsRequestSuccessAction = getShopsRequestSuccessAction;
exports.getShopsRequestFailAction = getShopsRequestFailAction;
exports.getShopsRequestAction = getShopsRequestAction;
exports.resetRegisterAction = resetRegisterAction;
exports.setInProcessAction = setInProcessAction;
exports.resetStateAction = resetStateAction;

var selectFile = function selectFile(state) {
  return state[REDUCER_NAME]['file'];
};

exports.selectFile = selectFile;

var selectUser = function selectUser(state) {
  return state[REDUCER_NAME]['user'];
};

exports.selectUser = selectUser;

var selectShops = function selectShops(state) {
  return state[REDUCER_NAME]['shops'];
};

exports.selectShops = selectShops;

var selectCategories = function selectCategories(state) {
  return state[REDUCER_NAME]['categories'];
};

exports.selectCategories = selectCategories;

var selectCommissions = function selectCommissions(state) {
  return state[REDUCER_NAME]['commissions'];
};

exports.selectCommissions = selectCommissions;

var selectExchangeAmount = function selectExchangeAmount(state) {
  return state[REDUCER_NAME]['exchangeAmount'];
};

exports.selectExchangeAmount = selectExchangeAmount;

var selectInProcess = function selectInProcess(state) {
  return state[REDUCER_NAME]['inProcess'];
};

exports.selectInProcess = selectInProcess;

var selectInSubmitProcess = function selectInSubmitProcess(state) {
  return state[REDUCER_NAME]['inSubmitProcess'];
};

exports.selectInSubmitProcess = selectInSubmitProcess;

var selectTransferRecipientShops = function selectTransferRecipientShops(state) {
  return state[REDUCER_NAME]['transferRecipientShops'];
};

exports.selectTransferRecipientShops = selectTransferRecipientShops;

var selectToken = function selectToken(state) {
  return state[REDUCER_NAME]['token'];
};

exports.selectToken = selectToken;
var name = slice['name'];
exports.name = name;
var reducer = slice['reducer'];
exports.reducer = reducer;